/* RESPONSIBLE TEAM: team-ai-agent */
import GuidanceController from 'embercom/controllers/apps/app/automation/fin-ai-agent/guidance';

export default class AutomationFinAIAgentEcommerceGuidanceController extends GuidanceController {}
